import "@/styles/global.css";

import { TablePreviewComponent } from "@/components/table-preview";
import { createPreviewStore, PreviewStoreContext } from "@/stores/preview";
import { useMemo } from "react";

export const TablePreview = ({
  workbookId,
  tableId,
}: {
  workbookId: string;
  tableId: string;
}) => {
  // 테이블이 바뀌면 store를 새로 만들어 당기 탭·편집모드·선택 상태를 초기화한다.
  const store = useMemo(
    () => createPreviewStore({ workbookId, tableId }),
    [workbookId, tableId],
  );

  return (
    <PreviewStoreContext.Provider value={store}>
      <div className="flex flex-col w-full h-full relative bg-white mx-auto rounded-lg shadow-lg overflow-y-scroll">
        <TablePreviewComponent />
      </div>
    </PreviewStoreContext.Provider>
  );
};
